import { GoalSubscriptionStatus } from '@models';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

function GoalSubscriptionStatusChip({ status }: { status: GoalSubscriptionStatus }) {
  const { t } = useTranslation();
  let text = '';
  let classes = '';

  switch (status) {
    case GoalSubscriptionStatus.PENDING_ACTIVE:
      text = t('domains.goalSubscriptions.status.pending');
      classes = classNames(setupForDark('bg-label-dark'));
      break;
    case GoalSubscriptionStatus.ACTIVE:
      text = t('domains.goalSubscriptions.status.active');
      classes = classNames(setupForDark('bg-label-violet'));
      break;
    case GoalSubscriptionStatus.PAUSED:
      text = t('domains.goalSubscriptions.status.paused');
      classes = classNames(setupForDark('bg-label-yellow'));
      break;
    case GoalSubscriptionStatus.COMPLETED:
      text = t('domains.goalSubscriptions.status.completed');
      classes = classNames(setupForDark('bg-label-green'));
      break;
    case GoalSubscriptionStatus.CANCELLED:
    case GoalSubscriptionStatus.DELETED:
      text = t('domains.goalSubscriptions.status.cancelled');
      classes = classNames(setupForDark('bg-label-red'));
      break;
    case GoalSubscriptionStatus.PENDING_DELETED:
      text = t('domains.goalSubscriptions.status.pending');
      classes = classNames(setupForDark('bg-label-dark'));
      break;
    case GoalSubscriptionStatus.ACQUIRED:
      text = t('domains.goalSubscriptions.status.acquired');
      classes = classNames(setupForDark('bg-yellow-700'));
      break;
    case GoalSubscriptionStatus.ACCESS_GRANTED:
      text = t('domains.goalSubscriptions.status.accessGranted');
      classes = classNames(setupForDark('bg-yellow-700'));
      break;
    default:
      text = '';
      classes = classNames('hidden');
  }

  return (
    <div
      data-testid={`goal-subscription-status-chip-${status}`}
      className={classNames(
        'flex justify-center items-center gap-none px-xxs rounded-xxs',
        'cursor-default',
        'P4R',
        'w-max',
        'text-nowrap',
        setupForDark('text-black'),
        classes
      )}
    >
      <div className='flex justify-between items-center gap-xxs'>{text}</div>
    </div>
  );
}

export default GoalSubscriptionStatusChip;
